<template>
  <div>
    <form @submit.prevent="submitAvail()">
      <select class="form-control" v-model='availability' @change='specificReason = null; note = "";'>
        <option v-for="(value,key) in UserAvailability" :key='key' :value='value'> {{key | splitCamel}} </option>
      </select>
      <div class="p-3">
        <div v-if='availability == 20'>
          <div class="form-check" v-for='reason in availabilityReasons.BusyReasons' :key='reason.id'>
            <input name="reason" class="form-check-input" type='radio' :id='reason.Id' v-model='specificReason' :value='reason' required />
            <label class="form-check-label" :for='reason.Id'>{{reason.Text}}</label>
          </div>
        </div>
        <div v-else-if='availability == 100'>
          <div class="form-check" v-for='reason in availabilityReasons.UnavailableReasons' :key='reason.id'>
            <input name="reason" class="form-check-input" type='radio' :id='reason.Id' v-model='specificReason' :value='reason' required />
            <label class="form-check-label" :for='reason.Id'>{{reason.Text}}</label>
          </div>
        </div>
      </div>
      <div v-if='specificReason'>
        <div class="form-group" v-if='specificReason.IsNoteShown && availability != 10'>
          <label for='noteArea'>Reason</label>
          <textarea class="form-control" name='noteArea' v-model='note' />
        </div>
        <div class="form-group row" v-if='availability ==20'>
          <label class="col-4 form-control-label" >Busy for:</label>
          <input class="form-control col-3" name='time' type='number' v-model='time' />
          <span class="col-5"><small>minutes [1:120]</small></span>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class='btn btn-outline' @click='cancelAvail()'>
          Cancel
        </button>
        <button class='btn btn-primary'>Update</button>
      </div>

    </form>
  </div>
</template>

<script>
  import {
    UserAvailability
  } from '@/lib/utilities/enums'

  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger'
  export default {
    computed: {
      UserAvailability: function () {
        return UserAvailability;
      }
    },
    data() {
      return {
        availability: 0,
        specificReason: null,
        time: 15,
        note: '',
        availabilityReasons: {}
      }
    },
    props: [
      'user'
    ],
    filters: {
      splitCamel: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace(/([A-Z])/g, ' $1').trim()
      }
    },
    methods: {
      submitAvail() {
        let vm = this;
        let availabilityPayload = {}
        if (vm.availability == 20) {
          availabilityPayload.time = vm.time;
        }
        if (vm.specificReason) {
          availabilityPayload.reason = vm.specificReason.Id;
        }
        availabilityPayload.availability = vm.availability;
        availabilityPayload.note = vm.note;
        vm.$emit('submitavail', availabilityPayload)
      },
      cancelAvail() {
        let vm = this;
        vm.$emit('cancel')
      }
    },
    created() {
      let vm = this;
      vm.availability = vm.user.Availability
      MessengerAPIClient.getAvailabilityReasons().then(function (reasons) {
        console.log(reasons)
        vm.availabilityReasons = Object.assign({}, reasons)

      })
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/Availability/Availability.vue